import Address from './Address';
import Attribute from './Attribute';
import CalendarEvent from './CalendarEvent';
import Carousel from './Carousel';
import Cart from './Cart';
import Catalog from './Catalog';
import Category from './Category';
import CategoryList from './CategoryList';
import EmployeeSchedule from './EmployeeSchedule';
import EventReservation from './EventReservation';
import InventoryBuffer from './InventoryBuffer';
import Offer from './Offer';
import Order from './Order';
import PaymentType from './PaymentType';
import Preorder from './Preorder';
import Product from './Product';
import ProductList from './ProductList';
import Role from './Role';
import ScheduleChangeRequest from './ScheduleChangeRequest';
import ShipmentManifest from './ShipmentManifest';
import Shop from './Shop';
import ShopEmployee from './ShopEmployee';
import ShopSale from './ShopSale';
import ShortUrl from './ShortUrl';
import Sidebar from './Sidebar';
import StockAccount from './StockAccount';
import Supplier from './Supplier';
import SupplierOrder from './SupplierOrder';
import Unit from './Unit';
import User from './User';
import VacationRequest from './VacationRequest';
import Voucher from './Voucher';

const Structures = {
    Address,
    Attribute,
    CalendarEvent,
    Catalog,
    Category,
    EmployeeSchedule,
    Order,
    Product,
    Role,
    ScheduleChangeRequest,
    ShipmentManifest,
    Shop,
    ShopEmployee,
    User,
    Offer,
    PaymentType,
    ProductList,
    Carousel,
    Supplier,
    SupplierOrder,
    CategoryList,
    ShopSale,
    Sidebar,
    StockAccount,
    Unit,
    Cart,
    VacationRequest,
    Voucher,
    Preorder,
    InventoryBuffer,
    ShortUrl,
    EventReservation
}

export default Structures;
